import { forwardRef } from "react";

import { Box, BoxProps } from "@mui/material";

import { mergeSx } from "@/common/helpers/mergeSx";
import { useDynamicThemeAwareVariables } from "@/common/hooks/useDynamicThemeAwareVariables";
import ApplePayButtonContentReverse from "@/icons/illustration/stripe-apple-pay-preview-reverse.svg";
import ApplePayButtonContent from "@/icons/illustration/stripe-apple-pay-preview.svg";

export const StripeExpressCheckoutApplePayPreview = forwardRef<HTMLDivElement, BoxProps>(({ sx, ...rest }, ref) => {
  const { backgroundColor, useReverseSvg } = useDynamicThemeAwareVariables(({ mode }) => ({
    backgroundColor: mode === "light" ? "black" : "white",
    useReverseSvg: mode === "dark",
  }));

  return (
    <Box
      ref={ref}
      sx={mergeSx(
        {
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          height: "44px",
          paddingInline: 2,
          backgroundColor,
          borderRadius: 1,
          ["& > svg"]: {
            height: "100%",
          },
        },
        sx
      )}
      {...rest}
    >
      {useReverseSvg ? <ApplePayButtonContentReverse /> : <ApplePayButtonContent />}
    </Box>
  );
});

StripeExpressCheckoutApplePayPreview.displayName = "StripeExpressCheckoutApplePayPreview";
